import { BannerDetailInfo, DrawerBanner } from 'widgets/banner';
import { useEffect } from 'react';
import { setActionBtnTitle, setHeaderAction } from 'features/ui/model/uiSlice';
import { useAppDispatch } from 'app/store';
import { UpdateBannerCard } from 'entities/banner';

export const BannerDetailPage = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setHeaderAction('edit'));
    dispatch(setActionBtnTitle('Изменить данные'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, [dispatch]);

  return (
    <>
      <BannerDetailInfo />
      <DrawerBanner title="Обновить баннер">
        <UpdateBannerCard />
      </DrawerBanner>
    </>
  );
};
